import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { apiUrl } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ContactoService {
  constructor(private http: HttpClient) {}

  sendEmail(data: any): Observable<any> {
    let body = {
      request_data: {
        type_action: 'send_email',
        data: {
          apellido: data['apellido'],
          nombre: data['nombre'],
          mensaje: data['mensaje'],
          correo: data['correo'],
          telefono: data['telefono'],
        },
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.post(`${apiUrl.BASE_URL}/usuarios`, body);
  }
}
